import React from 'react';

import { useScrolledPast } from '../../../shared/hooks/useScrolledPast';
import * as colors from '../../../theme/colors';

const SCROLL_THRESHOLD = 80;

// The menu handlers also set this colour, so it stays state and the scroll
// position only overrides it when the header threshold is crossed.
export const useNavBackgroundColor = () => {
  const [navBackGroundColor, setNavBackGroundColor] = React.useState(colors.white);
  const isScrolledPast = useScrolledPast(SCROLL_THRESHOLD);

  React.useEffect(() => {
    setNavBackGroundColor(isScrolledPast ? colors.lightGradient : colors.white);
  }, [isScrolledPast]);

  return [navBackGroundColor, setNavBackGroundColor];
};

export default useNavBackgroundColor;
